export default IconTallymark4 => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-tallymark-4" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M6 5l0 14" />
  <path d="M10 5l0 14" />
  <path d="M14 5l0 14" />
  <path d="M18 5l0 14" />
</svg>`;